import { render, staticRenderFns } from "./BCheckbox.vue?vue&type=template&id=8406ccb6"
import script from "./BCheckbox.vue?vue&type=script&lang=js"
export * from "./BCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BCheckbox.vue?vue&type=style&index=0&id=8406ccb6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports